export default class FluidVid {
    constructor() {
        this.iframes = document.getElementsByTagName('iframe');
        this.playersRegex = /www.youtube.com|player.vimeo.com/;

        this.responsifyVids();
    }

    responsifyVids() {
        for (let i = 0; i < this.iframes.length; i += 1) {
            const iframe = this.iframes[i];

            if (iframe.src.search(this.playersRegex) > 0) {
                iframe.width = '100%';
                iframe.height = '100%';

                const figure = iframe.parentNode;
                figure.className = 'fluid-vids';
                figure.style.width = '100%';
                figure.style.height = '100%';
                figure.style.position = 'relative';

                figure.appendChild(iframe);
            }
        }
    }
}



// WEBPACK FOOTER //
// ./frontend/js/modules/fluidvid.js